export default (function (o) {
  return o !== undefined && o !== null && typeof o.then === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/utils/promise/thenable.js
// module id = ff2u
// module chunks = 88